import { isAdminLabelAA } from '../../../../../services/AccountService'
import {
  dataEditReportStatuses,
  dataEditStatuses,
  getCanAddPicsAA,
  infoEditStatuses,
} from '../../../consts/request-body-data'
import { RequestType } from '../../../types/Request.type'
import { RequestDrawerModeType } from '../../SingleRequestDrawer/RequestDrawerStore'

export const formatEquipmentId = (id: string) => {
  //  XXXXX XXX XXX XXX
  return id
    .toString()
    .split('')
    .map((el, i) => ([4, 7, 10].includes(i) ? `${el} ` : el))
    .join('')
}

export const getCanEditData = (
  mode: RequestDrawerModeType,
  request: RequestType,
): boolean => {
  const case2 = request.status === 6 && request.dataCheckingStatus !== 2
  const case7 = request.status === 13 && request.reportStatus === 2
  const case8 =
    request.reportStatus === 3 &&
    request.dataCheckingStatus === 1 &&
    request.status === 13

  switch (mode) {
    case 'data':
      const case1 = infoEditStatuses.includes(request.status)
      const case3 =
        isAdminLabelAA() &&
        (dataEditReportStatuses.includes(request.reportStatus ?? -1) ||
          getCanAddPicsAA(request))

      return (
        Boolean(case1) ||
        Boolean(case2) ||
        Boolean(case3) ||
        Boolean(case7) ||
        Boolean(case8)
      )

    default:
      const case4 = dataEditStatuses.includes(request.status)
      const case5 =
        isAdminLabelAA() &&
        request.status === 15 &&
        dataEditReportStatuses.includes(request.reportStatus ?? -1)

      return (
        Boolean(case4) ||
        Boolean(case2) ||
        Boolean(case5) ||
        Boolean(case7) ||
        Boolean(case8)
      )
  }
}
